import resume from '../assets/pdf/resume.pdf'
import img from '../assets/png/pic.jpg'

export const headerData = {
    name: 'Prattay Dhar Logna',
    title: "Front-End Web Developer",
    desciption:"Passionate junior front-end developer with a desire to learn and grow in a collaborative team environment. Skilled in HTML, CSS, React Js, Node Js, Express Js, MongoDB, Firebase and JavaScript. Excels at creating pixel-perfect designs and working with cross-browser compatibility issues.",
    image:img,
    resumePdf: resume
}
